export const tryCatch = async (asyncFunction) => {
  let error;
  let result;

  try {
    result = await asyncFunction();
  } catch (capturedError) {
    error = capturedError;
  }

  return [error, result];
};
